import React, { useState, useEffect, useRef } from "react";
import "../../styles/ChartsBarsCSS/AuditCalender.css";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import { Modal } from "antd";


const UpcomingAuditModal = ({ open, onClose, upAudsData, selectedAuditDate }) => {
  const [selectedDate, setSelectedDate] = useState(upAudsData[0]?.audit_date || null);

  const dateRef = useRef(null);
  const auditInfoRef = useRef(null);

  const groupAuditsByDate = (data) => {
    return data.reduce((acc, item) => {
      const { audit_date } = item;
      if (!acc[audit_date]) {
        acc[audit_date] = [];
      }
      acc[audit_date].push(item);
      return acc;
    }, {});
  };

  const groupedAudits = groupAuditsByDate(upAudsData);

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const auditBoxes = auditInfoRef.current?.children;
    const auditIndex = Object.keys(groupedAudits).indexOf(date);
    if (auditBoxes?.[auditIndex]) {
      auditBoxes[auditIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    const dateBoxes = dateRef.current?.children;
    if (dateBoxes?.[auditIndex]) {
      dateBoxes[auditIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    if (!selectedDate && upAudsData.length > 0) {
      setSelectedDate(upAudsData[0].audit_date);
    }
  }, [upAudsData, selectedDate])

  return (
    <Modal
      title={selectedAuditDate ? `Audits on ${moment(selectedAuditDate).format("DD MMM YYYY")}` : "Upcoming Audits"}
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      // destroyOnClose
      destroyOnHidden
      styles={{ body: { maxHeight: "75vh", overflowY: "auto" } }}
    >
      <div className="calendar-containerds justify-content-center align-items-center shadow-lg">
        {upAudsData.length === 0 ? (
          <div className="no-audits-message">There are no upcoming audits</div>
        ) : (
          <>
            <div className="audit-info d-flex flex-column" ref={auditInfoRef}>
              {Object.entries(groupedAudits).map(
                ([audit_date, audits], index) => (
                  <div key={index} className="audit-group">
                    {audits.map((item, auditIndex) => (
                      <div
                        key={auditIndex}
                        className={`audit-box my-2 ${selectedDate === audit_date ? "selected" : "selected"} d-flex`}
                      >
                        <div className="box-left text-start">
                          <p><strong>Store Name:</strong></p>
                          <p><strong>Date:</strong></p>
                        </div>
                        <div className="box-right">
                          <p>{item.audit.store.name}, {item.audit.store.city.name}</p>
                          <p>{item?.audit_date ? moment(item.audit_date).format("DD-MMM-YYYY") : "N/A"}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
            <div className="know-more text-end mt-3">
              <Link to="/up-coming-audits" className="btn btn-text">
                View all upcoming audits →
              </Link>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default UpcomingAuditModal;
